export enum LLMType {
  CLAUDE = "claude",
  CLAUDE_37 = "claude-3.7",
  CLAUDE_37_WEB_SEARCH = "claude-3.7-web-search",
  OPENAI = "openai",
  OPENAI_41 = "openai-4.1",
  LLAMA = "llama",
  GPT_5_MINI = "gpt-5-mini",
  GPT_52 = "gpt-5.2",
  GPT_52_CHAT = "gpt-5.2-chat-latest",
  CLAUDE_SONNET_4 = "claude sonnet 4",
  CLAUDE_SONNET_4_5 = "claude sonnet 4.5",
  CLAUDE_SONNET_4_5_LARGE_CONTEXT = "claude sonnet 4.5 - large context",
  CLAUDE_SONNET_4_5_WEB_SEARCH = "claude sonnet 4.5 - web search",
  CLAUDE_HAIKU_4_5 = "claude haiku 4.5",
  CLAUDE_OPUS_4_5 = "claude opus 4.5",
  CLAUDE_SONNET_5_5 = "claude sonnet 5.5",
  CLAUDE_SONNET_5_5_WEB_SEARCH = "claude sonnet 5.5 - web search",
}

// Preferred model for chats that send a fixed request default instead of the
// user-selected model (Help chat, Project IQ diagnostic chat). It is only used
// when the user's available models include it (see resolveAssistantLlmType in
// utils/llmModelMigration); otherwise FALLBACK_ASSISTANT_LLM_TYPE is used.
// Change these two values to move the default.
export const DEFAULT_ASSISTANT_LLM_TYPE = LLMType.CLAUDE_SONNET_5_5;
export const FALLBACK_ASSISTANT_LLM_TYPE = LLMType.CLAUDE_SONNET_5_5;
